import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import UserDashboard from "./components/Dashboard/UserDashboard";
// import Attendance from "./components/Dashboard/Attendance";
import AdminDashboard from "./components/Dashboard/Admin/AdminDashboard";
import LeaveManagement from "./components/Dashboard/LeaveManagement";
import ProtectedRoute from "./components/ProtectedRoute";  // Assuming you have this component
import { Box } from "@mui/material";
import Logout from "./components/Auth/Logout"; // Add this import
import ForgotPassword from "./components/Auth/ForgotPassword";
import 'bootstrap/dist/css/bootstrap.min.css';
import EmployeePage from './components/EmployeePage';
import WorkLocationPage from "./components/WorkLocationPage";
import TaskPage from "./components/TaskPage";
import ShiftPage from "./components/ShiftPage";
import AttendancePage from "./components/AttendancePage";
import CheckedInDetails from "./components/CheckedInDetails";
import CheckedOutDetails from "./components/CheckedOutDetails";
import AbsentDetails from "./components/AbsentDetails";
import LeaveDetails from "./components/LeaveDetails";
import PendingApprovalLeave from "./components/PendingApprovalLeave";
import StartTaskDetails from "./components/StartTaskDetails";
import PendingTaskDetails from "./components/PendingTaskDetails";
import CompletedTaskDetails from "./components/CompletedTaskDetails";


function App() {
  return (
    <Router>
      <MainApp /> {/* Render MainApp inside Router to make use of useLocation */}
      
    </Router>
  );
}

function MainApp() {
  const location = useLocation();

  // List of routes where navbar should not be shown
  const noNavbarRoutes = ["/forgot-password", "/signup", "/"];

  return (
    <Box display="flex">
      {/* Conditionally render Navbar only if the route is not in noNavbarRoutes */}
      {!noNavbarRoutes.includes(location.pathname) && <Navbar />} {/* Sidebar */}

      <Box flexGrow={1} padding={0}> {/* Main Content */}
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* <Route path="/attendance" element={<Attendance />} /> */}
          <Route path="/leave-management" element={<LeaveManagement />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/work-location" element={<WorkLocationPage />} />
          <Route path="/task-page" element={<TaskPage />} />
          <Route path="/shift-page" element={<ShiftPage />} />
          <Route path="/attendance-page" element={<AttendancePage />} />
          <Route path="/CheckedInDetails/:type" element={<CheckedInDetails />} />
          <Route path="/checkedout-details/:type" element={<CheckedOutDetails />} />
          <Route path="/absent-details/:type" element={<AbsentDetails />} />
          <Route path="/leave-details/:type" element={<LeaveDetails />} />
          <Route path="/pending-details/:type" element={<PendingApprovalLeave />} />
          <Route path="/task-details/start" element={<StartTaskDetails />} />
<Route path="/task-details/pending" element={<PendingTaskDetails />} />
<Route path="/task-details/completed" element={<CompletedTaskDetails />} />
          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
                              <UserDashboard />
              
            }
          />
         

          <Route
            path="/employees"
            element={
              
                <EmployeePage />
             
            }
          />

          {/* Logout Route */}
          <Route path="/logout" element={<Logout />} />
        </Routes>
      </Box>
    </Box>
  );
}

export default App;
